import { ArrowLeft, CircleX } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '../../components/layout/page-layout'
import { Container } from '../../components/ui/container'

export default function SubscriptionCancelPage() {
  const { t } = useTranslation()

  return (
    <PageLayout>
      <Container>
        <div className='mx-auto max-w-2xl py-10'>
          <div className='rounded-2xl border border-amber-200 bg-white p-8 shadow-sm'>
            <div className='flex items-center gap-3 text-amber-700'>
              <CircleX className='h-8 w-8' />
              <h1 className='text-2xl font-semibold text-gray-900'>{t('subscription.cancelTitle')}</h1>
            </div>

            <p className='mt-4 text-sm leading-6 text-gray-600'>{t('subscription.cancelMessage')}</p>

            <div className='mt-6 rounded-xl border border-amber-100 bg-amber-50 px-4 py-3 text-sm text-amber-800'>
              {t('subscription.cancelHint')}
            </div>

            <div className='mt-8'>
              <Link
                to='/subscription'
                className='inline-flex items-center gap-2 rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700'
              >
                <ArrowLeft className='h-4 w-4' />
                {t('subscription.backToSubscription')}
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </PageLayout>
  )
}
